import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '予約作成',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: true,
};
